'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keymap = _interopDefault(require('../keymap/index.js'));
require('prosemirror-transform');
require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');
var index_js = require('../utils/index.js');
var index_js$1 = require('../cursor/index.js');
var index_js$2 = require('../table/index.js');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

function setAlign(align) {
  return function (state, dispatch, view) {
    const {
      selection,
      tr
    } = state;
    let transaction; // 处于 CellSelection 时可能有多个 range

    selection.ranges.forEach(range => {
      const from = range.$from.pos;
      const to = range.$to.pos;
      tr.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.type.spec.alignBlock) return;

        const newAttrs = objectSpread({}, node.attrs, {
          align
        });

        try {
          transaction = tr.setNodeMarkup(pos, null, newAttrs);
        } catch (e) {}
      });
    }); // 虚拟光标前后的块

    if (selection instanceof index_js$1.GapCursor) {
      const {
        $from,
        dom
      } = selection;
      const {
        nodeBefore,
        nodeAfter,
        pos
      } = $from;
      if (!dom) return false;
      let domPos;

      try {
        domPos = view.docView.posFromDOM(dom);
      } catch (error) {
        return false;
      }

      if (nodeAfter && nodeAfter.type.spec.alignBlock && nodeAfter.type.isAtom && domPos === pos) {
        const newAttrs = objectSpread({}, nodeAfter.attrs, {
          align
        });

        transaction = tr.setNodeMarkup(pos, null, newAttrs);
      }

      if (nodeBefore && nodeBefore.type.spec.alignBlock && nodeBefore.type.isAtom && domPos < pos) {
        const newAttrs = objectSpread({}, nodeBefore.attrs, {
          align
        });

        transaction = tr.setNodeMarkup(pos - 1, null, newAttrs);
      }
    }

    if (!transaction) return false;

    if (dispatch) {
      dispatch(transaction);
      view.focus();
    }

    return true;
  };
} // 设置文本格式

const handleListClick = listType => (state, dispatch, view, editor) => {
  const {
    listCommands,
    listUtils
  } = editor;

  if (!listCommands) {
    return;
  }

  if (listUtils.judgeListType(state, listType)) {
    listCommands.unwrapList();
  } else if (!listUtils.isInList(state)) {
    listCommands.wrapInList(listType);
  } else {
    listCommands.transformList(listType);
  }

  view.focus();
};
const setOL = (editor, state, dispatch, view) => {
  const {
    ordered_list
  } = state.schema.nodes;
  const command = handleListClick(ordered_list);
  command(state, dispatch, view, editor);
  return true;
};
const setUL = (editor, state, dispatch, view) => {
  const {
    bullet_list
  } = state.schema.nodes;
  const command = handleListClick(bullet_list);
  command(state, dispatch, view, editor);
  return true;
};
const setLink = (editor, state, dispatch) => {
  const attrs = editor.linkUtils.getLinkAttrs(state, dispatch);

  if (attrs) {
    editor.linkStore.openModal(attrs);
  }

  return true;
}; // 快速选中块内容

function quickSelect(state, dispatch, view) {
  const {
    tr,
    selection,
    schema,
    doc
  } = state;
  const {
    $from
  } = selection;
  const {
    note_content,
    note_title,
    collapse_title,
    collapse_content,
    status,
    table
  } = schema.nodes;
  const contentBlocks = [note_content, note_title, collapse_title, collapse_content, status, table];
  const foundNode = index_js.findParentNode($from.path, node => contentBlocks.includes(node.type));

  if (foundNode) {
    let newSelection;
    const pos = foundNode.pos;
    const node = foundNode.node;

    switch (foundNode.node.type) {
      case collapse_title:
      case collapse_content:
      case note_title:
      case note_content:
      case status:
        newSelection = prosemirrorState.TextSelection.create(doc, pos + 1, pos + node.nodeSize - 1);
        break;

      case table:
        const lastCell = node.lastChild.lastChild;
        newSelection = new index_js$2.CellSelection(doc.resolve(pos + 2), doc.resolve(pos + node.nodeSize - lastCell.nodeSize - 2));
        break;
    }

    dispatch(tr.setSelection(newSelection));
    view.focus();
  } else if (selection instanceof prosemirrorState.NodeSelection && contentBlocks.includes(selection.node.type)) {
    const {
      from,
      to
    } = selection;
    const newSelection = prosemirrorState.TextSelection.create(doc, from + 1, to - 1);
    dispatch(tr.setSelection(newSelection));
    view.focus();
  }
} // 带样式复制

function copyWithStyle() {
  // TODO 移除全局变量
  // @ts-ignore
  window.__EDITOR_COPY_WITH_STYLE__ = true;
  document.execCommand("Copy");
  return true;
}

/**
 * @desc [keymapGroup -- 匹配快捷键后会调用event.preventDefault]
 */
const IS_MAC = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
function buildKeymap(getEditor) {
  const keys = {};

  const bind = (key, cmd) => keys[key] = cmd;

  for (let i = 1; i <= 6; i++) {
    bind(`Mod-${i}`, () => {
      const editor = getEditor();
      editor.basicCommands.setTextBlockType(editor.view.state.schema.nodes.heading, {
        level: i
      });
      return true;
    });
  }

  return keys;
}
function createPlugins(module) {
  const getEditor = () => module.editor;

  const plugins = [keymap({
    // 有序
    "Shift-Mod-o": (...args) => setOL(getEditor(), ...args),
    "Shift-Mod-O": (...args) => setOL(getEditor(), ...args),
    // 无序
    "Shift-Mod-u": (...args) => setUL(getEditor(), ...args),
    "Shift-Mod-U": (...args) => setUL(getEditor(), ...args),
    // 中划线
    "Shift-Mod-s": () => {
      getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strikethrough);
      return true;
    },
    "Shift-Mod-S": () => {
      getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strikethrough);
      return true;
    },
    // 超链接
    "Mod-k": (state, dispatch) => setLink(getEditor(), state, dispatch),
    "Mod-K": (state, dispatch) => setLink(getEditor(), state, dispatch),
    // 左对齐
    "Shift-Mod-l": setAlign("left"),
    "Shift-Mod-I": setAlign("left"),
    // 居中
    "Shift-Mod-c": setAlign("center"),
    "Shift-Mod-C": setAlign("center"),
    // 右对齐
    "Shift-Mod-r": setAlign("right"),
    "Shift-Mod-R": setAlign("right"),
    // 正文
    "Mod-0": () => getEditor().basicCommands.setTextBlockType(getEditor().view.state.schema.nodes.paragraph),
    // 加粗
    "Mod-b": () => getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strong),
    "Mod-B": () => getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.strong),
    // 斜体
    "Mod-i": () => getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.em),
    "Mod-I": () => getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.em),
    // 下划线
    "Mod-u": () => getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.underline),
    "Mod-U": () => getEditor().basicCommands.toggleMark(getEditor().view.state.schema.marks.underline),
    // 插入时间宏
    "Mod-Alt-t": () => getEditor().timeStore.insertTime(),
    "Mod-Alt-T": () => getEditor().timeStore.insertTime(),
    // 插入代码宏
    "Mod-Alt-c": () => getEditor().codeCommands.insert(),
    "Mod-Alt-C": () => getEditor().codeCommands.insert(),
    // 快速选中
    "Mod-Shift-a": quickSelect,
    "Mod-Shift-A": quickSelect,
    // 引用
    "Mod-8": state => getEditor().quoteCommands.toggle(state)
  }), keymap(buildKeymap(getEditor))];

  if (IS_MAC) {
    plugins.push(keymap({
      // 带样式复制
      "Mod-Ctrl-c": copyWithStyle,
      "Mod-Ctrl-C": copyWithStyle
    }));
  } else {
    plugins.push(keymap({
      // 带样式复制
      "Mod-Alt-c": copyWithStyle,
      "Mod-Alt-C": copyWithStyle
    }));
  }

  return plugins;
}

class KeymapGroupModule {
  constructor() {
    this.name = "keymapGroup";
    this.editor = void 0;
    this.plugins = void 0;
    this.plugins = createPlugins(this);
  }

  init(editor) {
    this.editor = editor;
  }

}
KeymapGroupModule.moduleName = "keymapGroup";

exports.KeymapGroupModule = KeymapGroupModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/keymapGroup/index.js